<mnc-pac-interrupted-stay-form
  lazyComponent
  [interruptedStay]="interruptedStay"
  [tenantId]="tenantId"
  [productId]="productId"
  [isExternal]="isExternal"
  (formChanged)="onFormChange($event.detail)"
  (interruptedStayActionChanged)="interruptedStayActionChanged($event.detail)"
></mnc-pac-interrupted-stay-form>

<div class="flex justify-end mt-6">
  <div>
    <button
      pButton
      label="Cancel"
      class="p-button-secondary mr-2"
      type="button"
      data-test-id="cancel-request-button"
      (click)="onCancel()"
    ></button>
  </div>
  <div>
    <button
      pButton
      type="button"
      data-test-id="confirm-button"
      [label]="confirmButtonName"
      [disabled]="!interruptedStayFormValue || isInterruptedFormInvalid"
      [loading]="isLoading"
      (click)="onProceed()"
    ></button>
  </div>
</div>

<p-toast position="bottom-left" key="csr-redirect" (onClose)="navigateToServiceLine()"></p-toast>
<p-toast position="bottom-left" key="interruption"></p-toast>
